<template>
    <div style="position: relative;">
        <PannellumView class="bg" :panorama-image="currentView.image" :hotspots="currentView.hotspots || []"
            :initial-view="currentView.initialView || {}" @panorama-loaded="onPanoramaLoaded"
            @video-play="handleVideoPlay" @video-close="handleVideoClose" />
        <div class="menu">
            <button :class="showMenu ? 'menu-btn' : 'menu-btn2'" @click="handleClick">
                <img :src="images.menu" class="menu-img" alt="">
                <span class="menu-label">菜单</span>
            </button>
            <button v-if="showMenu" :class="buttonStates.search ? 'menu-btn' : 'menu-btn2'"
                @click="toggleButton('search')">
                <img :src="images.poster" class="menu-img" alt="">
                <span class="menu-label">光荣榜</span>
            </button>
            <button v-if="showMenu" :class="buttonStates.voice ? 'menu-btn' : 'menu-btn2'"
                @click="toggleButton('voice')">
                <img :src="images.voice" class="menu-img" alt="">
                <span class="menu-label">讲解</span>
            </button>
            <button v-if="showMenu" :class="buttonStates.share ? 'menu-btn' : 'menu-btn2'"
                @click="toggleButton('share')">
                <img :src="images.share" class="menu-img" alt="">
                <span class="menu-label">分享</span>
            </button>
            <button v-if="showMenu" :class="buttonStates.music ? 'menu-btn' : 'menu-btn2'"
                @click="toggleButton('music')">
                <img :src="images.music" class="menu-img" alt="">
                <span class="menu-label">音乐</span>
            </button>

        </div>

        <!-- 左上角统计信息 -->
        <!-- <div class="stats-panel">
            <div class="stats-item">
                <span class="stats-icon">❤️</span>
                <span class="stats-count">{{ likeCount }}</span>
            </div>
            <div class="stats-item">
                <span class="stats-icon">📤</span>
                <span class="stats-count">{{ shareCount }}</span>
            </div>
        </div> -->

        <!-- 右侧导览栏 -->
        <div class="guide-sidebar" :class="{ 'guide-sidebar-open': showGuide }">
            <div class="guide-toggle" @click="toggleGuide">
                <span v-if="!showGuide">导览</span>
                <span v-else>收起</span>
            </div>
            <div class="guide-content" v-if="showGuide">
                <div class="guide-sidebar-title">展厅导览</div>
                <div class="guide-sidebar-list">
                    <div class="guide-sidebar-item" @click="jumpToHall(0)">
                        <div class="guide-sidebar-icon">📍</div>
                        <div class="guide-sidebar-text">
                            <div class="guide-sidebar-name">序厅</div>
                        </div>
                    </div>
                    <div class="guide-sidebar-item" @click="jumpToHall(2)">
                        <div class="guide-sidebar-icon">🏛️</div>
                        <div class="guide-sidebar-text">
                            <div class="guide-sidebar-name">第一展厅</div>
                        </div>
                    </div>
                    <div class="guide-sidebar-item" @click="jumpToHall(3)">
                        <div class="guide-sidebar-icon">🏛️</div>
                        <div class="guide-sidebar-text">
                            <div class="guide-sidebar-name">第二展厅</div>
                        </div>
                    </div>
                    <div class="guide-sidebar-item" @click="jumpToHall(7)">
                        <div class="guide-sidebar-icon">🏛️</div>
                        <div class="guide-sidebar-text">
                            <div class="guide-sidebar-name">第三展厅</div>
                        </div>
                    </div>
                    <div class="guide-sidebar-item" @click="jumpToHall(10)">
                        <div class="guide-sidebar-icon">🎯</div>
                        <div class="guide-sidebar-text">
                            <div class="guide-sidebar-name">尾厅</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bar">
            <div class="left">
                <div class="bar-btn-container">
                    <button class="bar-btn" @click="prevView">
                        <img :src="images.left" class="bar-img" alt="">
                    </button>
                    <span class="bar-btn-label">上一页</span>
                </div>
                <div class="bar-btn-container" style="margin-left: 20px;">
                    <button class="bar-btn" @click="nextView">
                        <img :src="images.right" class="bar-img" alt="">
                    </button>
                    <span class="bar-btn-label">下一页</span>
                </div>
            </div>
            <div class="right">
                <div class="bar-btn-container">
                    <button class="bar-btn" @click="handleGood">
                        <img :src="images.good" class="bar-img" alt="">
                    </button>
                    <span class="bar-btn-label">为榜样点赞</span>
                </div>
                <div class="bar-btn-container" style="margin-left: 20px;">
                    <button class="bar-btn" @click="handleComment">
                        <img :src="images.message" class="bar-img" alt="">
                    </button>
                    <span class="bar-btn-label">想对模范说</span>
                </div>
            </div>
        </div>
        <!-- 修改评论弹窗部分 -->
        <Popup v-model="showComment" :safe-area-inset-bottom="true" :lock-scroll="false" position="bottom" round
            :style="{ backgroundColor: '#fff2e1' }">
            <div class="popup-container">
                <div class="comment_title">
                    {{ totalComments }}条留言
                </div>
                <List class="comment_panel" v-model="loading" :finished="finished" finished-text="没有更多了" @load="load">
                    <div class="comment_item" v-for="item, index in commentList" :key="index">
                        <div class="comment_user">{{ item.name }}</div>
                        <div class="comment_content">
                            {{ item.message }}
                        </div>
                        <div class="comment_time">{{ formatTime(item.createdTime) }}</div>
                    </div>
                </List>
                <div class="comment_bottom">
                    <div style="display: flex;">
                        <input class="comment_input" placeholder="想对模范说" v-model="newCommentContent" />
                        <button @click="submitComment"
                            style="margin-left: 10px; background: #7A000F; color: white; border: none; border-radius: 35px; padding: 0 20px;white-space: nowrap;">发送</button>
                    </div>
                </div>
            </div>
        </Popup>

        <Popup v-model="showSearch" :safe-area-inset-bottom="true" :lock-scroll="false" position="bottom" round
            :style="{ backgroundColor: '#fff2e1' }">
            <div class="search-container">
                <div class="search_input">
                    <input class="search_input_text" placeholder="输入名字" v-model="searchKeyword" @input="handleSearch" />
                    <button class="search_icon"></button>
                </div>
                <!-- 搜索结果列表 -->
                <div v-if="searchKeyword && searchResults.length > 0" class="search_results">
                    <div class="search_result_item" v-for="(result, index) in searchResults" :key="index"
                        @click="selectSearchResult(result)">
                        <div class="search_result_user">{{ result['名字'] }}</div>
                    </div>
                </div>
                <!-- 无搜索结果提示 -->
                <div v-else-if="searchKeyword && searchResults.length === 0" class="no_results">
                    未找到相关结果
                </div>
                <div v-else class="search_results2">
                    <div class="search_result_item" v-for="(result, index) in users" :key="index"
                        @click="selectSearchResult(result)">
                        <div class="search_result_user">{{ result['名字'] }}</div>
                    </div>
                </div>
            </div>
        </Popup>

        <Overlay :show="showPoster" :z-index="2000">
            <div class="wrapper" @click.stop>
                <div class="bottom_poster">
                    <!-- 分享图片的缩放容器 -->
                    <ZoomableContent v-if="!isLikeShare" ref="zoomableContentShare" key="share-image" :min-scale="0.05" :max-scale="2" :initial-scale="0.05" :auto-fit="true" :fit-scale="0.05">
                        <img :src="images.shareIcon" class="mid_poster">
                    </ZoomableContent>
                    <!-- 点赞canvas的缩放容器 -->
                    <ZoomableContent v-if="isLikeShare" ref="zoomableContentLike" key="like-canvas" :min-scale="0.05" :max-scale="2" :initial-scale="0.05" :auto-fit="true" :fit-scale="0.05">
                        <canvas ref="likeShareCanvas" class="mid_poster"></canvas>
                    </ZoomableContent>
                </div>
                <div class="bottom_menu">
                    <div class="share">
                        <div @click="shareWebpage(index)" class="share_item" v-for="(icon, index) in shareIcons"
                            :key="index">
                            <div class="">
                                <img class="share_icon" :src="icon['icon']" alt="">
                            </div>
                            <div>
                                {{ icon['name'] }}
                            </div>
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="cancel">
                        <div @click="closePosterModal">
                            取消
                        </div>
                    </div>
                </div>
            </div>
        </Overlay>

        <Overlay :show="newPoster" :z-index="2000">
            <div class="wrapper" @click.stop>
                <div class="bottom_poster">
                    <ZoomableContent ref="zoomableContent2" key="poster-canvas" :min-scale="0.1" :max-scale="2" :initial-scale="0.1" :auto-fit="true" :fit-scale="0.4">
                        <canvas ref="posterCanvas" class="poster-canvas"></canvas>
                    </ZoomableContent>
                </div>
                <div class="bottom_menu">
                    <div class="share">
                        <div @click="share(index)" class="share_item" v-for="(icon, index) in shareIcons" :key="index">
                            <div class="">
                                <img class="share_icon" :src="icon['icon']" alt="">
                            </div>
                            <div>
                                {{ icon['name'] }}
                            </div>
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="cancel">
                        <div @click="closeNewPosterModal">
                            取消
                        </div>
                    </div>
                </div>
            </div>
        </Overlay>

        <!-- 微信长按保存图片弹窗 -->
        <Overlay :show="showWechatImage" :z-index="2001" @click="showWechatImage = false">
            <div class="wechat-image-wrapper" @click.stop>
                <div class="wechat-image-tip">
                    长按图片保存或分享
                </div>
                <img :src="wechatImageUrl" class="wechat-image" alt="长按保存图片" />
                <div class="wechat-image-close" @click="showWechatImage = false">
                    关闭
                </div>
            </div>
        </Overlay>

        <!-- 点赞特效容器 -->
        <div class="like-effects">
            <div v-for="like in likes" :key="like.id" class="like-effect" :style="{
                left: like.x + 'px',
                top: like.y + 'px',
                fontSize: like.size + 'px',
                color: like.color,
                '--translate-x': like.translateX + 'px',
                '--translate-y': like.translateY + 'px',
                '--rotate': like.rotate + 'deg',
                '--duration': like.duration + 's'
            }">
                ❤️
            </div>
        </div>
    </div>
</template>

<script>
import PannellumView from '../components/Panorama.vue'
import ZoomableContent from '../components/ZoomableContent.vue'
import { Overlay, List, Popup } from 'vant';
import axios from 'axios';
import users1Raw from '../assets/group1.json';
import users2Raw from '../assets/group2.json';
import users3Raw from '../assets/group3.json';

// 给每个人物添加展厅信息
const users1 = users1Raw.map(user => ({ ...user, 展厅: 1 }));
const users2 = users2Raw.map(user => ({ ...user, 展厅: 2 }));
const users3 = users3Raw.map(user => ({ ...user, 展厅: 3 }));

// 合并所有人物用于搜索
const allUsers = [...users1, ...users2, ...users3];
import preloadService from '../services/preloadService';
import webviewBridge from '../services/webviewBridge';
import { panoramaViews, audioMap, bgMusicList } from './viewData';

// 分享图标使用 OSS 地址，在 data 中定义

export default {
    name: 'ViewPage',
    components: {
        Overlay,
        List,
        Popup,
        PannellumView,
        ZoomableContent
    },
    data() {
        const OSS_BASE_URL = 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets';

        return {
            // OSS 资源路径
            OSS_BASE_URL: OSS_BASE_URL,
            // 原始图标URL（用于预加载）
            originalImages: {
                menu: `${OSS_BASE_URL}/menu.png`,
                voice: `${OSS_BASE_URL}/voice.png`,
                share: `${OSS_BASE_URL}/share.png`,
                music: `${OSS_BASE_URL}/music.png`,
                poster: `${OSS_BASE_URL}/光荣榜.png`,
                left: `${OSS_BASE_URL}/left.png`,
                right: `${OSS_BASE_URL}/right.png`,
                good: `${OSS_BASE_URL}/good.png`,
                message: `${OSS_BASE_URL}/message.png`,
                shareIcon: `${OSS_BASE_URL}/sharePoster2.png`,
                poster1: `${OSS_BASE_URL}/poster1.png`,
                poster1Jpg: `${OSS_BASE_URL}/poster1.jpg`,
                search: `${OSS_BASE_URL}/search.png`,
            },
            newPoster: false,
            showSearch: false,
            showGuide: false,
            showComment: false,
            showMenu: false,
            likes: [],
            likeId: 0,
            // 每个按钮的独立状态
            buttonStates: {
                guide: false,
                voice: false, // 默认不播放语音讲解
                share: false,
                music: true, // 默认开启背景音乐
                search: false,
                good: false,
                comment: false
            },
            // 视频播放前的音频状态（用于恢复）
            audioStateBeforeVideo: {
                voice: false,
                music: true
            },
            // 讲解音频相关
            audioPlayer: null,
            currentAudio: '',
            audioMap: audioMap,
            // 背景音乐相关
            bgMusicPlayer: null,
            bgMusicList: bgMusicList,
            currentBgMusicIndex: 0,
            currentIndex: 0,
            views: panoramaViews,
            showPoster: false,
            shareIcons: [
                {
                    'icon': `${OSS_BASE_URL}/1.png`,
                    'name': '保存本地'
                },
                {
                    'icon': `${OSS_BASE_URL}/2.png`,
                    'name': '微信'
                },
                {
                    'icon': `${OSS_BASE_URL}/3.png`,
                    'name': '朋友圈'
                },
                {
                    'icon': `${OSS_BASE_URL}/5.png`,
                    'name': '微信收藏'
                },
            ],
            loading: false,
            finished: false,
            commentList: [],
            users: allUsers, // 显示所有人物
            searchKeyword: '',
            searchResults: [],
            selectedUserHall: 1, // 当前选中人物的展厅（1/2/3）
            selectedUserName: '', // 当前选中人物的名字
            maxSearchResults: 10,
            text: '',
            newCommentContent: '',
            userName: '', // 从 webview 获取的用户名

            // 分页相关数据
            currentPage: 0,
            pageSize: 10,
            totalComments: 0,

            // API 地址
            api: 'https://api.xjdx.top',

            // 添加组件状态管理
            componentState: {
                isDestroyed: false,
                isMounted: false
            },

            // 定时器引用
            resizeTimer: null,
            likeTimers: [],

            // 预加载状态追踪（用于触发响应式更新）
            preloadCounter: 0,

            // 点赞和分享统计
            likeCount: 0,
            shareCount: 0,

            // 微信环境检测（从全局获取）
            isWeChat: false,

            // 微信长按保存图片相关
            showWechatImage: false,
            wechatImageUrl: '',
            
            // 点赞分享标志
            isLikeShare: false
        }
    },
    computed: {
        currentView() {
            // 依赖 preloadCounter 以触发响应式更新
            // eslint-disable-next-line no-unused-vars
            const _ = this.preloadCounter;

            const view = this.views[this.currentIndex];

            // 直接从全局预加载服务获取最新的缓存状态
            const cached = preloadService.getPreloadedImage(view.image);

            if (cached && cached.blobUrl) {
                return {
                    ...view,
                    image: cached.blobUrl
                };
            }

            return view;
        },
        // 根据当前索引计算对应的 id
        // 0-1: 序厅, 2: 第一展厅, 3-7: 第二展厅, 8-9: 第三展厅, 10-11: 尾厅
        currentApiId() {
            if (this.currentIndex >= 0 && this.currentIndex <= 1) {
                return 0; // 序厅
            } else if (this.currentIndex === 2) {
                return 1; // 第一展厅
            } else if (this.currentIndex >= 3 && this.currentIndex <= 7) {
                return 2; // 第二展厅
            } else if (this.currentIndex >= 8 && this.currentIndex <= 11) {
                return 3; // 第三展厅和尾厅
            }
            return 1; // 默认返回第一展厅
        },
        // 根据选中人物的展厅获取海报模板图片（优先使用预加载的缓存）
        currentPosterTemplate() {
            // 依赖 preloadCounter 以触发响应式更新
            // eslint-disable-next-line no-unused-vars
            const _ = this.preloadCounter;

            // 使用选中人物的展厅，而不是当前浏览的展厅
            const hallId = this.selectedUserHall;
            const templates = {
                1: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/海报模板-第一展厅.jpg',
                2: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/海报模板-第二展厅.jpg',
                3: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/海报模板-第三展厅.jpg'
            };

            const originalUrl = templates[hallId] || templates[1];

            // 尝试从预加载服务获取缓存的 Blob URL
            const cached = preloadService.getPreloadedImage(originalUrl);
            if (cached && cached.blobUrl) {
                return cached.blobUrl;
            }

            return originalUrl;
        },
        // 动态返回图标URL，优先使用预加载后的Blob URL
        images() {
            // 依赖 preloadCounter 以触发响应式更新
            // eslint-disable-next-line no-unused-vars
            const _ = this.preloadCounter;

            const result = {};
            for (const [key, url] of Object.entries(this.originalImages)) {
                // 直接从全局预加载服务获取最新的缓存状态
                const cached = preloadService.getPreloadedImage(url);
                result[key] = (cached && cached.blobUrl) ? cached.blobUrl : url;
            }
            return result;
        }
    },
    mounted() {
        this.componentState.isMounted = true;
        this.componentState.isDestroyed = false;

        // 检测是否在微信环境中
        this.isWeChat = this.checkIsWeChat();

        // 从 webview 获取用户名
        this.getUserNameFromWebView();

        // 检测 URL 参数中是否有人物名字
        this.checkUrlCharacterParam();

        // 如果首页还没开始预加载，这里启动预加载
        if (!preloadService.isPreloading && preloadService.preloadedImages.size === 0) {
            this.preloadPanoramaImages();
        } else {
            // 继续预加载相邻图片
            this.preloadAdjacentImages();
            // 全景图已加载，开始预加载图标
            this.preloadIcons();
        }

        this.initAudio();
        this.initBgMusic();
        this.fetchStats(); // 获取点赞和分享统计
    },
    beforeDestroy() {
        this.componentState.isDestroyed = true;

        // 清理所有定时器
        this.likeTimers.forEach(timer => clearTimeout(timer));
        this.likeTimers = [];

        if (this.resizeTimer) {
            clearTimeout(this.resizeTimer);
        }

        // 清理讲解音频
        if (this.audioPlayer) {
            this.audioPlayer.pause();
            this.audioPlayer = null;
        }

        // 清理背景音乐
        if (this.bgMusicPlayer) {
            this.bgMusicPlayer.pause();
            this.bgMusicPlayer = null;
        }

        // 注意：不要在这里清理 Blob URLs，因为是全局共享的
        // 如果需要清理，应该在 App.vue 的 beforeDestroy 中调用 preloadService.cleanup()
    },
    methods: {
        // 检测是否在微信环境中
        checkIsWeChat() {
            const ua = navigator.userAgent.toLowerCase();
            return /micromessenger/.test(ua);
        },

        // 从 webview 获取用户名
        getUserNameFromWebView() {
            // 从 webviewBridge 获取用户名
            const name = webviewBridge.getUserName();
            if (name) {
                this.userName = name;
            }
        },

        // 检测 URL 参数中的人物名字
        checkUrlCharacterParam() {
            try {
                // 从 URL 中获取 character 参数
                const urlParams = new URLSearchParams(window.location.search);
                const characterName = urlParams.get('character');

                if (characterName) {

                    // 在人物列表中搜索该人物
                    const foundUser = this.users.find(user => user['名字'] === characterName);

                    if (foundUser) {

                        // 延迟执行，确保组件完全加载
                        this.$nextTick(() => {
                            setTimeout(() => {
                                // 自动展示该人物的海报信息
                                this.selectSearchResult(foundUser);
                            }, 500);
                        });
                    }
                }
            } catch (error) {
                console.error('❌ 检测 URL 参数失败:', error);
            }
        },

        // 加载自定义字体
        async loadCustomFont() {
            try {
                // 检查字体是否已加载
                if (document.fonts && document.fonts.check('600 30px FZYANSJW')) {
                    return true;
                }

                // 使用 FontFace API 加载字体
                const font = new FontFace(
                    'FZYANSJW',
                    'url(https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/FZYANSJW_CU.TTF)',
                    { weight: '600' }
                );

                await font.load();
                document.fonts.add(font);
                return true;
            } catch (error) {
                console.error('❌ 字体加载失败:', error);
                return false;
            }
        },

        // 绘制海报预览（使用 Canvas）
        async drawPosterPreview() {
            console.log('drawPosterPreview被调用，isLikeShare:', this.isLikeShare);
            try {
                const canvas = this.$refs.posterCanvas;
                if (!canvas) {
                    console.warn('Canvas 元素未找到');
                    return;
                }

                // 如果是点赞分享，直接在这里绘制点赞图片
                if (this.isLikeShare) {
                    console.log('在drawPosterPreview中绘制点赞图片，isLikeShare:', this.isLikeShare);
                    const ctx = canvas.getContext('2d');
                    
                    // 设置canvas尺寸，保持750:1046宽高比
                    canvas.width = 375; // 750/2 适合预览
                    canvas.height = 523; // 1046/2 适合预览
                    
                    // 清除canvas，保持透明
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    
                    // 加载点赞底图
                    const bgImage = new Image();
                    bgImage.crossOrigin = 'anonymous';
                    
                    bgImage.onload = () => {
                        console.log('点赞底图加载成功，开始绘制到第二个弹窗');
                        console.log('底图尺寸:', bgImage.width, 'x', bgImage.height);
                        console.log('canvas尺寸:', canvas.width, 'x', canvas.height);
                        try {
                            // 绘制背景图，填充整个canvas
                            ctx.drawImage(bgImage, 0, 0, canvas.width, canvas.height);
                            console.log('背景图绘制完成');
                            
                            // 绘制点赞数量，补齐到5位数
                            const likeText = (this.likeCount || 999).toString().padStart(5, '0');
                            console.log('绘制点赞数:', likeText);
                            
                            // 绘制每个数字的比分牌背景和数字
                            this.drawSeparateDigits(ctx, likeText, canvas.width / 2, canvas.height * 0.61, 49);
                            
                            console.log('第二个弹窗点赞图片绘制完成');
                            
                            // 重新计算缩放比例
                            this.$nextTick(() => {
                                if (this.$refs.zoomableContent2) {
                                    this.$refs.zoomableContent2.recalculate();
                                }
                            });
                        } catch (error) {
                            console.error('绘制过程出错:', error);
                        }
                    };
                    
                    bgImage.onerror = (error) => {
                        console.error('加载点赞底图失败:', error);
                        console.error('图片URL:', bgImage.src);
                        // 如果图片加载失败，使用纯色背景
                        ctx.fillStyle = '#FFE4E1';
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                        
                        const likeText = (this.likeCount || 999).toString().padStart(5, '0');
                        this.drawSeparateDigits(ctx, likeText, canvas.width / 2, canvas.height * 0.61, 49);
                        console.log('使用备用背景绘制完成');
                        
                        // 重新计算缩放比例
                        setTimeout(() => {
                            if (this.$refs.zoomableContent2) {
                                this.$refs.zoomableContent2.recalculate();
                            }
                        }, 200);
                    };
                    
                    // 使用点赞图片链接
                    const imageUrl = `${this.OSS_BASE_URL}/点赞.png`;
                    console.log('开始加载点赞底图:', imageUrl);
                    bgImage.src = imageUrl;
                    return;
                }

                // 加载自定义字体
                await this.loadCustomFont();

                // 获取文字内容
                let text = this.text;
                if (!text) {
                    return;
                }

                // 设置 Canvas 尺寸（高分辨率，用于生成高清图片）
                const width = 1100;
                const fontSize = 30;
                const fontFamily = 'FZYANSJW, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif';

                // 文字区域设置
                const padding = {
                    top: 710,
                    left: 156,
                    right: 156,
                    bottom: 100
                };
                const textWidth = width - padding.left - padding.right;
                const lineHeight = 45;

                // 先用临时 Canvas 计算文字行数
                const tempCanvas = document.createElement('canvas');
                const tempCtx = tempCanvas.getContext('2d');
                tempCtx.font = `600 ${fontSize}px ${fontFamily}`;

                const ctx = canvas.getContext('2d');

                // 计算缩进宽度
                const indentWidth = tempCtx.measureText('缩进').width;

                // 计算文字行数（考虑首行缩进）
                const lines = [];
                let currentLine = '';
                let isFirstLine = true;

                for (let i = 0; i < text.length; i++) {
                    const char = text[i];
                    const testLine = currentLine + char;
                    const metrics = tempCtx.measureText(testLine);

                    const availableWidth = isFirstLine ? textWidth - indentWidth : textWidth;

                    if (metrics.width > availableWidth && currentLine.length > 0) {
                        lines.push(currentLine);
                        currentLine = char;
                        isFirstLine = false;
                    } else {
                        currentLine = testLine;
                    }
                }
                if (currentLine) {
                    lines.push(currentLine);
                }

                // 计算所需高度
                const textHeight = lines.length * lineHeight;
                const minHeight = 1860;
                const requiredHeight = padding.top + textHeight + padding.bottom;
                const height = Math.max(minHeight, requiredHeight);

                // 设置 Canvas 实际尺寸
                canvas.width = width;
                canvas.height = height;

                // 加载并绘制背景图
                const bgImage = new Image();
                bgImage.crossOrigin = 'anonymous';

                await new Promise((resolve, reject) => {
                    bgImage.onload = resolve;
                    bgImage.onerror = reject;
                    bgImage.src = this.currentPosterTemplate;
                });

                ctx.drawImage(bgImage, 0, 0, width, height);

                // 设置文字样式
                ctx.fillStyle = '#92413F';
                ctx.font = `600 ${fontSize}px ${fontFamily}`;
                ctx.textBaseline = 'top';
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = 'high';

                // 绘制文字（两端对齐，首行缩进）
                let y = padding.top;

                lines.forEach((line, index) => {
                    const xPos = index === 0 ? padding.left + indentWidth : padding.left;
                    const lineWidth = index === 0 ? textWidth - indentWidth : textWidth;
                    const isLastLine = index === lines.length - 1;

                    this.drawJustifiedText(ctx, line, xPos, y, lineWidth, isLastLine);
                    y += lineHeight;
                });

                // 重新计算缩放比例
                setTimeout(() => {
                    if (this.$refs.zoomableContent2) {
                        this.$refs.zoomableContent2.recalculate();
                    }
                }, 200);

            } catch (error) {
                console.error('绘制海报预览失败:', error);
            }
        },

        // 绘制两端对齐的文字（精确算法，支持中英文数字混排）
        drawJustifiedText(ctx, text, x, y, maxWidth, isLastLine = false) {
            // 安全检查
            if (!text || text.length === 0) {
                return;
            }

            // 如果是最后一行，直接左对齐
            if (isLastLine) {
                ctx.fillText(text, x, y);
                return;
            }

            // 如果只有一个字符，直接左对齐
            if (text.length === 1) {
                ctx.fillText(text, x, y);
                return;
            }

            // 测量文字宽度
            const textWidth = ctx.measureText(text).width;

            // 如果文字宽度接近最大宽度（95%以上），进行两端对齐
            if (textWidth >= maxWidth * 0.95 && textWidth <= maxWidth * 1.05) {
                try {
                    // 将文字分割成字符数组
                    const chars = text.split('');
                    const charCount = chars.length;

                    // 如果字符太少，不进行两端对齐
                    if (charCount < 3) {
                        ctx.fillText(text, x, y);
                        return;
                    }

                    // 计算每个字符的精确宽度
                    const charWidths = chars.map(char => ctx.measureText(char).width);
                    const totalCharsWidth = charWidths.reduce((sum, width) => sum + width, 0);

                    // 计算需要分配的空白空间
                    const totalSpacing = maxWidth - totalCharsWidth;

                    // 计算每个间隙的基础宽度
                    const gapCount = charCount - 1;
                    const baseSpacing = totalSpacing / gapCount;

                    // 确保间距在合理范围内
                    if (baseSpacing < -2 || baseSpacing > 50) {
                        ctx.fillText(text, x, y);
                        return;
                    }

                    // 使用精确定位算法：为每个字符计算精确的 x 坐标
                    // 这样可以避免累积误差
                    const positions = [];
                    let accumulatedWidth = 0;

                    for (let i = 0; i < charCount; i++) {
                        if (i === 0) {
                            // 第一个字符在起始位置
                            positions.push(x);
                        } else if (i === charCount - 1) {
                            // 最后一个字符精确对齐到右边界
                            positions.push(x + maxWidth - charWidths[i]);
                        } else {
                            // 中间字符按比例分布
                            // 计算理想位置：起始位置 + 已占用的字符宽度 + 应有的间距
                            const idealX = x + accumulatedWidth + (baseSpacing * i);
                            positions.push(idealX);
                        }
                        accumulatedWidth += charWidths[i];
                    }

                    // 绘制每个字符到计算好的位置
                    chars.forEach((char, index) => {
                        ctx.fillText(char, positions[index], y);
                    });

                } catch (error) {
                    // 如果出现任何错误，回退到左对齐
                    console.warn('两端对齐绘制失败，使用左对齐:', error);
                    ctx.fillText(text, x, y);
                }
            } else {
                // 文字较短或过长，使用左对齐
                ctx.fillText(text, x, y);
            }
        },

        // 静默预加载全景图（后台加载，不阻塞用户操作）
        preloadPanoramaImages() {
            const panoramaUrls = this.views.map(view => view.image);

            // 优先加载当前和相邻的图片
            const priorityUrls = [
                panoramaUrls[this.currentIndex], // 当前图片
                panoramaUrls[this.currentIndex + 1], // 下一张
                panoramaUrls[this.currentIndex - 1] || panoramaUrls[panoramaUrls.length - 1], // 上一张
            ].filter(Boolean);

            // 先加载优先级高的图片
            priorityUrls.forEach((url, index) => {
                this.preloadImage(url, index === 0 ? 'high' : 'medium');
            });

            // 然后加载其他图片（延迟加载，避免占用太多带宽）
            setTimeout(() => {
                panoramaUrls.forEach((url, index) => {
                    if (!priorityUrls.includes(url)) {
                        // 使用 requestIdleCallback 在浏览器空闲时加载
                        if (window.requestIdleCallback) {
                            window.requestIdleCallback(() => {
                                this.preloadImage(url, 'low');
                            });
                        } else {
                            // 降级方案：延迟加载
                            setTimeout(() => {
                                this.preloadImage(url, 'low');
                            }, index * 200); // 每张图片间隔 200ms
                        }
                    }
                });

                // 全景图加载完成后，开始预加载图标
                setTimeout(() => {
                    this.preloadIcons();
                }, 2000); // 等待2秒后开始预加载图标
            }, 1000); // 1秒后开始加载其他图片
        },

        // 预加载单张图片（使用全局预加载服务）
        preloadImage(url, priority = 'low') {
            return preloadService.preloadImage(url, priority).then(result => {
                // 预加载完成后，增加计数器触发响应式更新
                this.preloadCounter++;
                return result;
            });
        },

        // 预加载所有图标
        preloadIcons() {

            // 收集所有需要预加载的图标URL
            const iconUrls = [
                // 菜单图标
                this.originalImages.menu,
                this.originalImages.voice,
                this.originalImages.share,
                this.originalImages.music,
                this.originalImages.poster,
                this.originalImages.left,
                this.originalImages.right,
                this.originalImages.good,
                this.originalImages.message,
                this.originalImages.search,
                // 分享图标
                ...this.shareIcons.map(icon => icon.icon)
            ];

            // 使用 requestIdleCallback 在浏览器空闲时预加载图标
            iconUrls.forEach((url, index) => {
                if (window.requestIdleCallback) {
                    window.requestIdleCallback(() => {
                        this.preloadImage(url, 'low');
                    });
                } else {
                    setTimeout(() => {
                        this.preloadImage(url, 'low');
                    }, index * 100); // 每个图标间隔 100ms
                }
            });

            // 图标加载完成后，预加载分享相关图片
            setTimeout(() => {

                // 分享链接图片
                this.preloadImage(this.originalImages.shareIcon, 'low');

                // 三个展厅的海报模板
                this.preloadImage('https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/海报模板-第一展厅.jpg', 'low');
                this.preloadImage('https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/海报模板-第二展厅.jpg', 'low');
                this.preloadImage('https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/海报模板-第三展厅.jpg', 'low');
            }, iconUrls.length * 100 + 500); // 等待图标加载完成后再加载
        },

        // 统一更新微信分享配置的方法
        updateWechatShare(shareData) {

            // 分享给朋友
            wx.onMenuShareAppMessage({
                title: shareData.title,
                desc: shareData.desc,
                link: shareData.link,
                imgUrl: shareData.imgUrl,
                success: () => {
                }
            });

            // 分享到朋友圈
            wx.onMenuShareTimeline({
                title: shareData.title,
                link: shareData.link,
                imgUrl: shareData.imgUrl,
                success: () => {
                }
            });

        },

        openComment() {
            this.showComment = true;
            this.currentPage = 0;
            this.totalComments = 0;
            this.commentList = [];
            this.load();
        },
        formatTime(isoTime) {
            if (!isoTime) return '';

            try {
                const date = new Date(isoTime);

                if (isNaN(date.getTime())) {
                    return isoTime;
                }

                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');

                return `${year}-${month}-${day} ${hours}:${minutes}`;
            } catch (error) {
                console.error('时间格式化错误:', error);
                return isoTime;
            }
        },
        async submitComment() {
            if (!this.newCommentContent.trim()) {
                alert('请输入评论内容');
                return;
            }

            try {
                const response = await axios.post(this.api + '/comments', {
                    content: this.newCommentContent,
                    id: this.currentApiId,
                    time: new Date().toISOString(),
                    name: this.userName || '匿名' // 添加用户名字段，如果没有则使用"游客"
                });

                let newComment = {};
                if (response.data && response.data.data) {
                    newComment = response.data.data;
                } else {
                    newComment = response.data;
                }

                this.commentList.unshift(newComment);
                this.newCommentContent = '';

            } catch (error) {
                console.error('提交评论失败:', error);
                if (error.code === 'ERR_NETWORK') {
                    alert('网络连接失败，请检查后端服务是否运行');
                } else {
                    alert('提交评论失败，请稍后重试');
                }
            }
        },

        async fetchComments(page = 1) {
            try {
                const response = await axios.get(this.api + '/getComments', {
                    params: {
                        id: this.currentApiId,
                        page: page,
                        limit: this.pageSize
                    }
                });

                let comments = [];
                let totalItems = 0;
                comments = response.data.data;
                totalItems = response.data.pagination ? response.data.pagination.totalItems : 0;
                if (page === 1) {
                    this.commentList = comments;
                } else {
                    this.commentList.push(...comments);
                }

                this.totalComments = totalItems;
                this.currentPage = page;

                this.finished = this.commentList.length >= totalItems;
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.error('获取评论列表失败:', error);
                this.finished = true;

                if (error.code === 'ERR_NETWORK') {
                    console.error('网络连接失败，请检查后端服务是否运行');
                }
            }
        },

        load() {
            this.loading = true;
            this.fetchComments(this.currentPage + 1);
        },

        // 分享网页（第一个弹窗 - 分享图片和链接）
        async shareWebpage(index) {
            // 调用分享统计接口（类型：网页分享）
            await this.recordShare('webpage');

            // 如果在 WebView 中，调用原生分享
            if (webviewBridge.isWebView) {
                this.shareWebpageViaApp(index);
                return;
            }

            // 否则使用微信分享
            switch (index) {
                case 0: // 保存本地 - 保存分享图标
                    this.saveShareIcon();
                    break;
                case 1: // 微信好友
                    this.shareWebpageToWechat();
                    break;
                case 2: // 朋友圈
                    this.shareWebpageToMoments();
                    break;
                case 3: // 微信收藏
                    this.shareWebpageToFavorite();
                    break;
                default:
                    break;
            }
        },

        // 通过 App 分享网页
        async shareWebpageViaApp(index) {
            const currentUrl = window.location.href;

            // 使用与微信分享相同的配置
            const shareData = {
                type: 'webpage',
                title: '延庆区先进典型人物事迹展览',
                description: '妫川脊梁·时代荣光',
                url: currentUrl,
                imageUrl: this.originalImages.shareIcon,
                shareType: index // 0: 保存, 1: 微信, 2: 朋友圈, 3: 收藏
            };

            const success = webviewBridge.share(shareData);

            if (success) {
                this.showPoster = false;
            } else {
                alert('分享功能暂不可用');
            }
        },

        // 分享生成的图片（第二个弹窗 - 分享海报图片）
        async share(index) {
            // 调用分享统计接口（类型：图片分享）
            await this.recordShare('poster');

            // 如果在 WebView 中，调用原生分享
            if (webviewBridge.isWebView) {
                await this.sharePosterViaApp(index);
                return;
            }

            // 否则使用微信分享或保存本地
            switch (index) {
                case 0: // 保存本地
                    // 如果在微信环境中，展示图片而不是下载
                    if (this.isWeChat) {
                        await this.showImageForWechat();
                    } else {
                        await this.saveAsImage();
                    }
                    break;
                case 1: // 微信
                    this.shareToWechat();
                    break;
                case 2: // 朋友圈
                    this.shareToMoments();
                    break;
                case 3: // 微信收藏
                    await this.saveToWechatFavorite();
                    break;
                default:
                    // 如果在微信环境中，展示图片而不是下载
                    if (this.isWeChat) {
                        await this.showImageForWechat();
                    } else {
                        await this.saveAsImage();
                    }
                    break;
            }
            
            // 分享完成后延迟重置点赞分享标志，避免闪烁
            setTimeout(() => {
                this.isLikeShare = false;
            }, 100);
        },

        // 通过 App 分享海报图片
        async sharePosterViaApp(index) {
            try {
                let imageBase64;
                let title;
                let description;

                if (this.isLikeShare) {
                    // 点赞分享，使用点赞图片
                    imageBase64 = await this.generateLikeImage();
                    title = '点赞分享';
                    description = `当前点赞数：${this.likeCount}`;
                } else {
                    // 普通海报分享
                    imageBase64 = await this.generatePosterBase64();
                    title = this.selectedUserName ? `${this.selectedUserName}` : '延庆区先进典型人物事迹展览';
                    description = this.text || '延庆区先进典型人物事迹展览';
                }

                if (!imageBase64) {
                    alert('生成图片失败');
                    return;
                }

                const shareData = {
                    type: 'image',
                    title: title,
                    description: description,
                    imageBase64: imageBase64,
                    shareType: index // 0: 保存, 1: 微信, 2: 朋友圈, 3: 收藏
                };

                const success = webviewBridge.share(shareData);

                if (success) {
                    this.newPoster = false;
                } else {
                    alert('分享功能暂不可用');
                }
            } catch (error) {
                console.error('分享图片失败:', error);
                alert('分享失败: ' + error.message);
            }
        },

        // 生成海报图片的 Base64（用于 App 分享）
        async generatePosterBase64() {
            try {

                // 加载自定义字体
                await this.loadCustomFont();

                // 获取文字内容
                let text = this.text;
                if (!text) {
                    return null;
                }

                // 创建临时Canvas用于计算文字行数
                const tempCanvas = document.createElement('canvas');
                const tempCtx = tempCanvas.getContext('2d');

                // 设置文字样式（使用自定义字体）
                const width = 1100;
                const fontSize = 30;
                const fontFamily = 'FZYANSJW, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif';
                tempCtx.font = `600 ${fontSize}px ${fontFamily}`;

                // 文字区域设置
                const padding = {
                    top: 710,
                    left: 156,
                    right: 156,
                    bottom: 100
                };
                const textWidth = width - padding.left - padding.right;
                const lineHeight = 45;

                // 计算两个字符的缩进宽度（用于后续计算和绘制）
                const indentWidth = tempCtx.measureText('缩进').width;

                // 计算文字行数（考虑首行缩进）
                const lines = [];
                let currentLine = '';
                let isFirstLine = true;

                for (let i = 0; i < text.length; i++) {
                    const char = text[i];
                    const testLine = currentLine + char;
                    const metrics = tempCtx.measureText(testLine);

                    // 第一行需要减去缩进宽度
                    const availableWidth = isFirstLine ? textWidth - indentWidth : textWidth;

                    if (metrics.width > availableWidth && currentLine.length > 0) {
                        lines.push(currentLine);
                        currentLine = char;
                        isFirstLine = false;
                    } else {
                        currentLine = testLine;
                    }
                }
                if (currentLine) {
                    lines.push(currentLine);
                }

                // 计算所需高度
                const textHeight = lines.length * lineHeight;
                const minHeight = 1860;
                const requiredHeight = padding.top + textHeight + padding.bottom;
                const height = Math.max(minHeight, requiredHeight);

                // 创建最终Canvas
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = width;
                canvas.height = height;

                // 加载背景图
                const bgImage = new Image();
                bgImage.crossOrigin = 'anonymous';

                await new Promise((resolve, reject) => {
                    bgImage.onload = resolve;
                    bgImage.onerror = reject;
                    bgImage.src = this.currentPosterTemplate;
                });

                // 绘制背景图
                ctx.drawImage(bgImage, 0, 0, width, height);

                // 设置文字样式
                ctx.fillStyle = '#92413F';
                ctx.font = `600 ${fontSize}px ${fontFamily}`;
                ctx.textBaseline = 'top';
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = 'high';

                // 绘制文字（两端对齐，首行缩进）
                let y = padding.top;
                // 使用之前计算的 indentWidth

                lines.forEach((line, index) => {
                    // 第一行缩进两个字符
                    const xPos = index === 0 ? padding.left + indentWidth : padding.left;
                    const lineWidth = index === 0 ? textWidth - indentWidth : textWidth;
                    const isLastLine = index === lines.length - 1;

                    // 使用统一的绘制方法，传入是否为最后一行
                    this.drawJustifiedText(ctx, line, xPos, y, lineWidth, isLastLine);
                    y += lineHeight;
                });

                // 转换为 Base64
                const base64 = canvas.toDataURL('image/png', 1.0);

                return base64;
            } catch (error) {
                console.error('生成海报 Base64 失败:', error);
                return null;
            }
        },

        // 记录分享统计
        async recordShare(type) {
            try {
                // 调用分享统计接口
                const response = await axios.post(this.api + '/share', {
                    type: type, // 'webpage' 或 'poster'
                    timestamp: new Date().toISOString()
                });

                if (response.data.success) {

                    // 获取最新的分享数据
                    await this.fetchShareStats();
                } else {
                    console.error('分享统计失败:', response.data.message);
                }
            } catch (error) {
                console.error('分享统计接口调用失败:', error);
            }
        },

        // 获取分享统计数据
        async fetchShareStats() {
            try {
                const response = await axios.get(this.api + '/share');
                if (response.data.success) {
                    this.shareCount = response.data.data.shareCount;
                }
            } catch (error) {
                console.error('获取分享数据失败:', error);
            }
        },

        // 使用Canvas直接绘制高清海报
        async saveAsImage() {
            try {
                // 如果是点赞分享，使用点赞图片
                if (this.isLikeShare) {
                    const imageUrl = await this.generateLikeImage();
                    const link = document.createElement('a');
                    link.href = imageUrl;
                    link.download = 'like-' + new Date().getTime() + '.png';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    alert('点赞图片已保存');
                    return;
                }

                // 加载自定义字体
                await this.loadCustomFont();

                // 获取文字内容
                let text = this.text;
                if (!text) {
                    alert('没有内容可以生成');
                    return;
                }

                // 创建临时Canvas用于计算文字行数
                const tempCanvas = document.createElement('canvas');
                const tempCtx = tempCanvas.getContext('2d');

                // 设置文字样式（用于测量，使用自定义字体）
                const width = 1100; // 2倍于显示尺寸550px
                const fontSize = 30; // 15px * 2
                const fontFamily = 'FZYANSJW, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif';
                tempCtx.font = `600 ${fontSize}px ${fontFamily}`;

                // 文字区域设置（2倍于CSS中的padding）
                const padding = {
                    top: 710,    // 355px * 2
                    left: 156,   // 78px * 2
                    right: 156,  // 78px * 2
                    bottom: 100  // 底部留白
                };
                const textWidth = width - padding.left - padding.right;
                const lineHeight = 45; // 30px字体 * 1.5行高

                // 计算两个字符的缩进宽度（用于后续计算和绘制）
                const indentWidth = tempCtx.measureText('缩进').width;

                // 计算需要多少行（按字符宽度精确计算，考虑首行缩进）
                const lines = [];
                let currentLine = '';
                let isFirstLine = true;

                for (let i = 0; i < text.length; i++) {
                    const char = text[i];
                    const testLine = currentLine + char;
                    const metrics = tempCtx.measureText(testLine);

                    // 第一行需要减去缩进宽度
                    const availableWidth = isFirstLine ? textWidth - indentWidth : textWidth;

                    // 如果超出宽度且当前行不为空，则换行
                    if (metrics.width > availableWidth && currentLine.length > 0) {
                        lines.push(currentLine);
                        currentLine = char;
                        isFirstLine = false;
                    } else {
                        currentLine = testLine;
                    }
                }
                // 添加最后一行
                if (currentLine) {
                    lines.push(currentLine);
                }


                // 计算所需的总高度
                const textHeight = lines.length * lineHeight;
                const minHeight = 1860; // 最小高度（原始高度930px * 2）
                const requiredHeight = padding.top + textHeight + padding.bottom;
                const height = Math.max(minHeight, requiredHeight);

                // 创建最终Canvas
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = width;
                canvas.height = height;

                // 加载背景图（根据当前展厅选择模板）
                const bgImage = new Image();
                bgImage.crossOrigin = 'anonymous';

                await new Promise((resolve, reject) => {
                    bgImage.onload = resolve;
                    bgImage.onerror = reject;
                    bgImage.src = this.currentPosterTemplate;
                });


                // 绘制背景图（如果高度增加，则拉伸背景）
                ctx.drawImage(bgImage, 0, 0, width, height);

                // 设置文字样式（与测量时保持一致）
                ctx.fillStyle = '#92413F';
                ctx.font = `600 ${fontSize}px ${fontFamily}`;
                ctx.textBaseline = 'top';
                // 启用抗锯齿，提高文字渲染质量
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = 'high';

                // 绘制每一行文字（两端对齐，首行缩进）
                let y = padding.top;
                // 使用之前计算的 indentWidth

                lines.forEach((line, index) => {
                    // 第一行缩进两个字符
                    const xPos = index === 0 ? padding.left + indentWidth : padding.left;
                    const lineWidth = index === 0 ? textWidth - indentWidth : textWidth;
                    const isLastLine = index === lines.length - 1;

                    // 使用统一的绘制方法，传入是否为最后一行
                    this.drawJustifiedText(ctx, line, xPos, y, lineWidth, isLastLine);
                    y += lineHeight;
                });


                // 转换为图片并下载
                canvas.toBlob((blob) => {
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    // 使用人物名字作为文件名
                    const fileName = this.selectedUserName ? `${this.selectedUserName}.png` : `展览图片-${new Date().getTime()}.png`;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);

                    alert('高清图片已保存');
                    this.newPoster = false;
                }, 'image/png', 1.0);

            } catch (error) {
                console.error('生成图片失败:', error);
                alert('生成图片失败: ' + error.message);
            }
        },

        // 微信收藏
        async saveToWechatFavorite() {
            // 如果在微信环境中，展示图片而不是下载
            if (this.isWeChat) {
                await this.showImageForWechat();
            } else {
                // 先保存图片
                await this.saveAsImage();

                // 提示用户手动收藏
                setTimeout(() => {
                    alert('图片已保存到相册\n请打开微信选择任意聊天\n发送图片后长按图片选择"收藏"');
                }, 500);
            }
        },

        // 在微信中展示图片供用户长按保存
        async showImageForWechat() {
            try {
                // 如果是点赞分享，使用点赞图片
                if (this.isLikeShare) {
                    const imageUrl = await this.generateLikeImage();
                    this.wechatImageUrl = imageUrl;
                    this.showWechatImage = true;
                    this.newPoster = false;
                    return;
                }

                // 加载自定义字体
                await this.loadCustomFont();

                // 获取文字内容
                let text = this.text;
                if (!text) {
                    alert('没有内容可以生成');
                    return;
                }

                // 创建临时Canvas用于计算文字行数
                const tempCanvas = document.createElement('canvas');
                const tempCtx = tempCanvas.getContext('2d');

                // 设置文字样式
                const width = 1100;
                const fontSize = 30;
                const fontFamily = 'FZYANSJW, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif';
                tempCtx.font = `600 ${fontSize}px ${fontFamily}`;

                // 文字区域设置
                const padding = {
                    top: 710,
                    left: 156,
                    right: 156,
                    bottom: 100
                };
                const textWidth = width - padding.left - padding.right;
                const lineHeight = 45;

                // 计算缩进宽度
                const indentWidth = tempCtx.measureText('缩进').width;

                // 计算文字行数（考虑首行缩进）
                const lines = [];
                let currentLine = '';
                let isFirstLine = true;

                for (let i = 0; i < text.length; i++) {
                    const char = text[i];
                    const testLine = currentLine + char;
                    const metrics = tempCtx.measureText(testLine);

                    const availableWidth = isFirstLine ? textWidth - indentWidth : textWidth;

                    if (metrics.width > availableWidth && currentLine.length > 0) {
                        lines.push(currentLine);
                        currentLine = char;
                        isFirstLine = false;
                    } else {
                        currentLine = testLine;
                    }
                }
                if (currentLine) {
                    lines.push(currentLine);
                }

                // 计算所需高度
                const textHeight = lines.length * lineHeight;
                const minHeight = 1860;
                const requiredHeight = padding.top + textHeight + padding.bottom;
                const height = Math.max(minHeight, requiredHeight);

                // 创建最终Canvas
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = width;
                canvas.height = height;

                // 加载背景图
                const bgImage = new Image();
                bgImage.crossOrigin = 'anonymous';

                await new Promise((resolve, reject) => {
                    bgImage.onload = resolve;
                    bgImage.onerror = reject;
                    bgImage.src = this.currentPosterTemplate;
                });

                // 绘制背景图
                ctx.drawImage(bgImage, 0, 0, width, height);

                // 设置文字样式
                ctx.fillStyle = '#92413F';
                ctx.font = `600 ${fontSize}px ${fontFamily}`;
                ctx.textBaseline = 'top';
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = 'high';

                // 绘制文字（两端对齐，首行缩进）
                let y = padding.top;

                lines.forEach((line, index) => {
                    const xPos = index === 0 ? padding.left + indentWidth : padding.left;
                    const lineWidth = index === 0 ? textWidth - indentWidth : textWidth;
                    const isLastLine = index === lines.length - 1;

                    this.drawJustifiedText(ctx, line, xPos, y, lineWidth, isLastLine);
                    y += lineHeight;
                });

                // 转换为图片URL
                const imageUrl = canvas.toDataURL('image/png', 1.0);

                // 显示图片供用户长按保存
                this.wechatImageUrl = imageUrl;
                this.showWechatImage = true;
                this.newPoster = false;


            } catch (error) {
                console.error('生成图片失败:', error);
                alert('生成图片失败: ' + error.message);
            }
        },


        // 保存分享图标
        saveShareIcon() {
            const link = document.createElement('a');
            link.href = this.images.shareIcon;
            link.download = 'share-' + new Date().getTime() + '.png';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            alert('图片已保存');
        },

        // 生成点赞分享图片
        async generateLikeImage() {
            console.log('开始生成点赞图片，当前点赞数:', this.likeCount);
            const imageUrl = `${this.OSS_BASE_URL}/点赞.png`;
            console.log('使用点赞底图:', imageUrl);
            
            return new Promise((resolve, reject) => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                
                // 设置画布尺寸，保持750:1046宽高比（高分辨率）
                canvas.width = 750;
                canvas.height = 1046;
                
                // 清除canvas，保持透明背景
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                
                // 加载点赞底图
                const bgImage = new Image();
                bgImage.crossOrigin = 'anonymous';
                
                bgImage.onload = () => {
                    console.log('点赞底图加载成功，尺寸:', bgImage.width, 'x', bgImage.height);
                    try {
                        // 计算保持宽高比的绘制尺寸
                        const imgAspect = bgImage.width / bgImage.height;
                        const canvasAspect = canvas.width / canvas.height;
                        
                        let drawWidth, drawHeight, drawX, drawY;
                        
                        if (imgAspect > canvasAspect) {
                            // 图片更宽，以canvas宽度为准
                            drawWidth = canvas.width;
                            drawHeight = canvas.width / imgAspect;
                            drawX = 0;
                            drawY = (canvas.height - drawHeight) / 2;
                        } else {
                            // 图片更高，以canvas高度为准
                            drawHeight = canvas.height;
                            drawWidth = canvas.height * imgAspect;
                            drawX = (canvas.width - drawWidth) / 2;
                            drawY = 0;
                        }
                        
                        console.log('分享图绘制尺寸:', drawWidth, 'x', drawHeight, '位置:', drawX, drawY);
                        
                        // 绘制背景图，保持宽高比
                        ctx.drawImage(bgImage, drawX, drawY, drawWidth, drawHeight);
                        
                        // 绘制点赞数量，补齐到5位数
                        const likeText = (this.likeCount || 999).toString().padStart(5, '0');
                        console.log('绘制点赞数:', likeText);
                        
                        // 绘制每个数字的比分牌背景和数字（使用高分辨率参数）
                        const fontSize = 98; // 750/375 * 49 = 98，保持比例
                        this.drawSeparateDigits(ctx, likeText, canvas.width / 2, canvas.height * 0.61, fontSize);
                        
                        // 转换为图片URL
                        const resultUrl = canvas.toDataURL('image/png', 1.0);
                        console.log('点赞图片生成完成');
                        resolve(resultUrl);
                    } catch (error) {
                        console.error('绘制过程出错:', error);
                        reject(error);
                    }
                };
                
                bgImage.onerror = () => {
                    console.error('加载点赞底图失败，生成纯色图片');
                    try {
                        // 如果图片加载失败，生成纯色图片
                        ctx.fillStyle = '#FFE4E1';
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                        
                        ctx.font = 'bold 80px Arial, sans-serif';
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'middle';
                        
                        const likeText = (this.likeCount || 999).toString();
                        
                        // 绘制分离的数字，补齐到5位数
                        const paddedLikeText = likeText.padStart(5, '0');
                        this.drawSeparateDigits(ctx, paddedLikeText, canvas.width / 2, canvas.height * 0.61, 98);
                        
                        const resultUrl = canvas.toDataURL('image/png', 1.0);
                        resolve(resultUrl);
                    } catch (fallbackError) {
                        reject(fallbackError);
                    }
                };
                
                // 使用你提供的点赞图片链接
                bgImage.src = imageUrl;
            });
        },

        // 绘制比分牌样式背景
        drawScoreboardBackground(ctx, text, centerX, centerY, fontSize) {
            const digitWidth = fontSize * 0.7; // 每个数字的宽度
            const digitHeight = fontSize * 1.2; // 每个数字的高度
            const spacing = fontSize * 0.1; // 数字间距
            const totalWidth = text.length * digitWidth + (text.length - 1) * spacing;
            
            // 计算起始位置
            let startX = centerX - totalWidth / 2;
            
            // 为每个数字绘制背景
            ctx.fillStyle = '#FFDCBE';
            for (let i = 0; i < text.length; i++) {
                const digitX = startX + i * (digitWidth + spacing);
                const digitCenterX = digitX + digitWidth / 2;
                
                // 绘制上半部分正方形
                ctx.fillRect(
                    digitCenterX - digitWidth / 2, 
                    centerY - digitHeight / 2, 
                    digitWidth, 
                    digitHeight * 0.45
                );
                
                // 绘制下半部分正方形
                ctx.fillRect(
                    digitCenterX - digitWidth / 2, 
                    centerY + digitHeight * 0.05, 
                    digitWidth, 
                    digitHeight * 0.45
                );
            }
        },

        // 绘制分离的数字，每个数字都有独立的背景
        drawSeparateDigits(ctx, text, centerX, centerY, fontSize) {
            const squareSize = fontSize * 0.8; // 正方形的边长
            const gapSize = fontSize * 0.1; // 上下正方形之间的间隙
            const spacing = fontSize * 0.05; // 数字间距，进一步减少间距
            const totalWidth = text.length * squareSize + (text.length - 1) * spacing;
            
            // 计算起始位置
            let startX = centerX - totalWidth / 2;
            
            // 为每个数字分别绘制背景和数字
            for (let i = 0; i < text.length; i++) {
                const digitX = startX + i * (squareSize + spacing);
                const digitCenterX = digitX + squareSize / 2;
                
                // 绘制单个数字的背景
                ctx.fillStyle = '#FFDCBE';
                
                // 绘制上方的完整正方形
                ctx.fillRect(
                    digitCenterX - squareSize / 2, 
                    centerY - squareSize - gapSize / 2, 
                    squareSize, 
                    squareSize
                );
                
                // 绘制下方的完整正方形
                ctx.fillRect(
                    digitCenterX - squareSize / 2, 
                    centerY + gapSize / 2, 
                    squareSize, 
                    squareSize
                );
                
                // 绘制单个数字
                ctx.fillStyle = '#FC7818';
                ctx.font = `normal ${fontSize}px Arial, sans-serif`;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(text[i], digitCenterX, centerY);
            }
        },

        // 关闭分享弹窗
        closePosterModal() {
            this.isLikeShare = false;
            this.showPoster = false;
            // 重置分享弹窗的缩放状态，确保下次打开时状态正确
            this.$nextTick(() => {
                if (this.$refs.zoomableContentShare) {
                    this.$refs.zoomableContentShare.resetToInitialState();
                }
                if (this.$refs.zoomableContentLike) {
                    this.$refs.zoomableContentLike.resetToInitialState();
                }
            });
        },

        // 关闭新海报弹窗
        closeNewPosterModal() {
            this.isLikeShare = false;
            this.newPoster = false;
            // 重置第二个弹窗的缩放状态，确保下次打开时状态正确
            this.$nextTick(() => {
                if (this.$refs.zoomableContent2) {
                    this.$refs.zoomableContent2.resetToInitialState();
                }
            });
        },

        // 直接绘制点赞图片到第二个弹窗的canvas
        async drawLikeImageDirectly() {
            console.log('开始直接绘制点赞图片');
            try {
                const canvas = this.$refs.posterCanvas;
                console.log('posterCanvas:', canvas);
                if (!canvas) {
                    console.error('找不到posterCanvas元素');
                    return;
                }
                
                const ctx = canvas.getContext('2d');
                
                // 设置canvas尺寸
                canvas.width = 550;
                canvas.height = 400;
                console.log('设置canvas尺寸:', canvas.width, 'x', canvas.height);
                
                // 清除canvas
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                
                // 绘制测试背景
                ctx.fillStyle = '#F0F0F0';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                
                // 绘制点赞数量，补齐到5位数
                const likeText = (this.likeCount || 999).toString().padStart(5, '0');
                console.log('绘制点赞数:', likeText);
                
                // 绘制每个数字的比分牌背景和数字
                this.drawSeparateDigits(ctx, likeText, canvas.width / 2, canvas.height * 0.5, 40);
                
                console.log('点赞图片绘制完成');
            } catch (error) {
                console.error('绘制点赞图片失败:', error);
            }
        },

        // 绘制点赞图片到canvas预览
        async drawLikeImageToCanvas() {
            console.log('开始绘制点赞图片到canvas预览');
            console.log('isLikeShare:', this.isLikeShare);
            console.log('newPoster:', this.newPoster);
            console.log('showPoster:', this.showPoster);
            try {
                // 根据当前显示的弹窗选择对应的canvas
                const canvas = this.$refs.likeShareCanvas || this.$refs.posterCanvas;
                console.log('找到的canvas:', canvas ? 'posterCanvas' : 'none');
                if (!canvas) {
                    console.error('找不到canvas元素');
                    return;
                }
                
                const ctx = canvas.getContext('2d');
                
                // 设置canvas尺寸，统一使用750:1046宽高比
                canvas.width = 375; // 750/2 适合预览
                canvas.height = 523; // 1046/2 适合预览
                console.log('设置canvas尺寸:', canvas.width, 'x', canvas.height);
                
                // 清除canvas，保持透明背景
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                
                // 加载点赞底图
                const bgImage = new Image();
                bgImage.crossOrigin = 'anonymous';
                
                bgImage.onload = () => {
                    console.log('点赞底图加载成功，开始绘制');
                    console.log('原图尺寸:', bgImage.width, 'x', bgImage.height);
                    try {
                        // 保持宽高比绘制底图
                        const imgAspect = bgImage.width / bgImage.height;
                        const canvasAspect = canvas.width / canvas.height;
                        
                        let drawWidth, drawHeight, drawX, drawY;
                        
                        if (imgAspect > canvasAspect) {
                            // 图片更宽，以canvas宽度为准
                            drawWidth = canvas.width;
                            drawHeight = canvas.width / imgAspect;
                            drawX = 0;
                            drawY = (canvas.height - drawHeight) / 2;
                        } else {
                            // 图片更高，以canvas高度为准
                            drawHeight = canvas.height;
                            drawWidth = canvas.height * imgAspect;
                            drawX = (canvas.width - drawWidth) / 2;
                            drawY = 0;
                        }
                        
                        console.log('绘制尺寸:', drawWidth, 'x', drawHeight, '位置:', drawX, drawY);
                        ctx.drawImage(bgImage, drawX, drawY, drawWidth, drawHeight);
                        
                        // 设置文字样式
                        ctx.fillStyle = '#FC7818'; // 橙色文字
                        ctx.font = 'bold 64px Arial, sans-serif';
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'middle';
                        
                        // 绘制点赞数量，补齐到5位数
                        const likeText = (this.likeCount || 999).toString().padStart(5, '0');
                        console.log('在canvas上绘制点赞数:', likeText);
                        
                        // 绘制每个数字的比分牌背景和数字
                        this.drawSeparateDigits(ctx, likeText, canvas.width / 2, canvas.height * 0.61, 49);
                        
                        console.log('canvas绘制完成');
                        
                        // 重新计算缩放比例
                        this.$nextTick(() => {
                            if (this.$refs.zoomableContentLike) {
                                this.$refs.zoomableContentLike.recalculate();
                            }
                        });
                    } catch (error) {
                        console.error('绘制过程出错:', error);
                    }
                };
                
                bgImage.onerror = () => {
                    console.error('加载点赞底图失败，使用纯色背景');
                    // 如果图片加载失败，使用纯色背景
                    ctx.fillStyle = '#FFE4E1';
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    
                    ctx.font = 'bold 60px Arial, sans-serif';
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    
                    const likeText = (this.likeCount || 999).toString();
                    
                    // 绘制分离的数字，补齐到5位数
                    const paddedLikeText = likeText.padStart(5, '0');
                    this.drawSeparateDigits(ctx, paddedLikeText, canvas.width / 2, canvas.height * 0.61, 49);
                    
                    // 重新计算缩放比例
                    this.$nextTick(() => {
                        if (this.$refs.zoomableContentLike) {
                            this.$refs.zoomableContentLike.recalculate();
                        }
                    });
                };
                
                // 使用你提供的点赞图片链接
                const imageUrl = `${this.OSS_BASE_URL}/点赞.png`;
                console.log('开始加载点赞底图:', imageUrl);
                bgImage.src = imageUrl;
                
            } catch (error) {
                console.error('绘制canvas失败:', error);
            }
        },



        // 分享网页到微信好友
        async shareWebpageToWechat() {
            // 检测是否在微信环境中
            if (!this.isWeChat) {
                alert('请在微信中打开此页面进行分享');
                this.showPoster = false;
                return;
            }

            // 检查微信 SDK 是否已就绪
            if (!window.wxReady) {
                alert('微信初始化中，请稍后重试');
                return;
            }

            // 调用后端接口增加分享数
            try {
                const response = await axios.post(this.api + '/share');
                if (response.data.success) {
                    this.shareCount = response.data.data.shareCount;
                }
            } catch (error) {
                console.error('分享统计失败:', error);
            }

            this.showPoster = false;
            alert('分享内容已准备好\n请点击右上角"..."菜单\n选择"发送给朋友"进行分享');
        },

        // 分享网页到朋友圈
        async shareWebpageToMoments() {
            // 检测是否在微信环境中
            if (!this.isWeChat) {
                alert('请在微信中打开此页面进行分享');
                this.showPoster = false;
                return;
            }

            // 检查微信 SDK 是否已就绪
            if (!window.wxReady) {
                alert('微信初始化中，请稍后重试');
                return;
            }

            // 调用后端接口增加分享数
            try {
                const response = await axios.post(this.api + '/share');
                if (response.data.success) {
                    this.shareCount = response.data.data.shareCount;
                }
            } catch (error) {
                console.error('分享统计失败:', error);
            }

            this.showPoster = false;
            alert('分享内容已准备好\n请点击右上角"..."菜单\n选择"分享到朋友圈"进行分享');
        },

        // 分享网页到微信收藏
        shareWebpageToFavorite() {
            // 检测是否在微信环境中
            if (!this.isWeChat) {
                alert('请在微信中打开此页面进行收藏');
                this.showPoster = false;
                return;
            }

            alert('请点击右上角"..."菜单\n选择"收藏"进行收藏');
            this.showPoster = false;
        },

        // 微信好友分享（海报图片）
        async shareToWechat() {
            // 检测是否在微信环境中
            if (!this.isWeChat) {
                alert('请在微信中打开此页面进行分享');
                this.newPoster = false;
                return;
            }

            // 分享配置已经在全局设置（App.vue），这里只需要提示用户
            this.newPoster = false;
            alert('分享内容已准备好\n请点击右上角"..."菜单\n选择"发送给朋友"进行分享');
        },

        // 朋友圈分享（海报图片）
        async shareToMoments() {
            // 检测是否在微信环境中
            if (!this.isWeChat) {
                alert('请在微信中打开此页面进行分享');
                this.newPoster = false;
                return;
            }

            // 分享配置已经在全局设置（App.vue），这里只需要提示用户
            this.newPoster = false;
            alert('分享内容已准备好\n请点击右上角"..."菜单\n选择"分享到朋友圈"进行分享');
        },

        good(event) {
            const count = 1;
            for (let i = 0; i < count; i++) {
                const button = event.target;
                const rect = button.getBoundingClientRect();
                const x = rect.left + rect.width / 2;
                const y = rect.top + rect.height / 2;

                const colors = ['#ff6b6b', '#ff8e8e', '#ff5252', '#ff7676', '#ffb6c1', '#ff69b4'];
                const color = colors[Math.floor(Math.random() * colors.length)];
                const size = Math.random() * 15 + 15;

                const horizontalSpread = (Math.random() - 0.5) * 100;
                const verticalDistance = -(Math.random() * 100 + 50);
                const rotate = Math.random() * 60 - 30;
                const duration = Math.random() * 0.5 + 1;

                const like = {
                    id: this.likeId++,
                    x: x,
                    y: y,
                    color: color,
                    size: size,
                    translateX: horizontalSpread,
                    translateY: verticalDistance,
                    rotate: rotate,
                    duration: duration
                };

                this.likes.push(like);

                // 使用组件状态管理定时器
                const timer = setTimeout(() => {
                    if (!this.componentState.isDestroyed) {
                        this.likes = this.likes.filter(item => item.id !== like.id);
                    }
                }, duration * 1000);

                this.likeTimers.push(timer);
            }

            const button = event.target;
            button.classList.add('btn-animate');
            setTimeout(() => {
                if (!this.componentState.isDestroyed) {
                    button.classList.remove('btn-animate');
                }
            }, 300);
        },

        handleClick() {
            this.showMenu = !this.showMenu;
            // 关闭菜单时，重置所有菜单按钮状态
            if (!this.showMenu) {
                this.buttonStates.voice = false;
                this.buttonStates.share = false;
                this.buttonStates.music = false;
                this.buttonStates.search = false;
            }
        },

        // 切换按钮状态
        toggleButton(buttonName) {
            // 执行按钮对应的功能
            if (buttonName === 'voice') {
                // 切换语音讲解状态
                this.buttonStates.voice = !this.buttonStates.voice;
                this.toggleAudio();
            } else if (buttonName === 'share') {
                // 分享不改变状态，只打开弹窗
                this.isLikeShare = false; // 确保普通分享时重置点赞分享标志
                this.showPoster = true;
                // 确保分享弹窗的缩放组件完全重置
                this.$nextTick(() => {
                    if (this.isLikeShare && this.$refs.zoomableContentLike) {
                        // 先完全重置状态
                        this.$refs.zoomableContentLike.resetToInitialState();
                        // 然后重新计算
                        setTimeout(() => {
                            this.$refs.zoomableContentLike.recalculate();
                        }, 50);
                    } else if (!this.isLikeShare && this.$refs.zoomableContentShare) {
                        // 先完全重置状态
                        this.$refs.zoomableContentShare.resetToInitialState();
                        // 然后重新计算
                        setTimeout(() => {
                            this.$refs.zoomableContentShare.recalculate();
                        }, 50);
                    }
                });
            } else if (buttonName === 'music') {
                // 切换背景音乐状态
                this.buttonStates.music = !this.buttonStates.music;
                this.toggleBgMusic();
            } else if (buttonName === 'search') {
                // 搜索不改变状态，只打开弹窗
                this.showSearch = true;
            }
        },

        // 切换导览侧边栏
        toggleGuide() {
            this.showGuide = !this.showGuide;
        },

        // 跳转到指定展厅
        jumpToHall(index) {
            this.currentIndex = index;
            this.showGuide = false;
            this.changeUsers();
            this.playCurrentAudio();
            this.preloadAdjacentImages();
        },

        // 初始化音频
        initAudio() {
            this.audioPlayer = new Audio();
            this.audioPlayer.loop = true; // 循环播放
            this.playCurrentAudio();
        },

        // 播放当前全景图对应的音频
        playCurrentAudio() {
            const audioSrc = this.audioMap[this.currentIndex];

            // 如果当前全景图没有音频（如尾厅），停止播放并返回
            if (!audioSrc) {
                if (this.audioPlayer) {
                    this.audioPlayer.pause();
                    this.currentAudio = '';
                }
                return;
            }

            // 如果是同一个音频，不需要重新加载
            if (this.currentAudio === audioSrc) {
                if (this.buttonStates.voice && this.audioPlayer.paused) {
                    this.audioPlayer.play().catch(err => {
                        console.error('音频播放失败:', err);
                    });
                }
                return;
            }

            // 切换到新音频
            this.currentAudio = audioSrc;
            this.audioPlayer.src = audioSrc;

            if (this.buttonStates.voice) {
                this.audioPlayer.play().catch(err => {
                    console.error('音频播放失败:', err);
                });
            }
        },

        // 切换音频播放/暂停
        toggleAudio() {
            if (!this.audioPlayer) {
                this.initAudio();
                return;
            }

            if (this.buttonStates.voice) {
                // 开启语音讲解
                this.audioPlayer.play().catch(err => {
                    console.error('音频播放失败:', err);
                });
            } else {
                // 关闭语音讲解
                this.audioPlayer.pause();
            }
        },

        // 初始化背景音乐
        initBgMusic() {
            this.bgMusicPlayer = new Audio();
            this.bgMusicPlayer.volume = 0.3; // 设置音量为30%，避免太吵

            // 监听播放结束事件，自动播放下一首
            this.bgMusicPlayer.addEventListener('ended', () => {
                this.playNextBgMusic();
            });

            // 开始播放第一首
            this.playBgMusic(0);
        },

        // 播放指定索引的背景音乐
        playBgMusic(index) {
            if (!this.bgMusicPlayer || !this.bgMusicList[index]) {
                return;
            }

            this.currentBgMusicIndex = index;
            this.bgMusicPlayer.src = this.bgMusicList[index];

            if (this.buttonStates.music) {
                this.bgMusicPlayer.play().catch(err => {
                    console.error('背景音乐播放失败:', err);
                });
            }
        },

        // 播放下一首背景音乐
        playNextBgMusic() {
            const nextIndex = (this.currentBgMusicIndex + 1) % this.bgMusicList.length;
            this.playBgMusic(nextIndex);
        },

        // 切换背景音乐播放/暂停
        toggleBgMusic() {
            if (!this.bgMusicPlayer) {
                this.initBgMusic();
                return;
            }

            if (this.buttonStates.music) {
                // 开启背景音乐
                this.bgMusicPlayer.play().catch(err => {
                    console.error('背景音乐播放失败:', err);
                });
            } else {
                // 关闭背景音乐
                this.bgMusicPlayer.pause();
            }
        },

        // 处理点赞按钮（不改变状态，只执行功能）
        async handleGood(event) {
            this.good(event);
            // 调用后端接口增加点赞数
            try {
                const response = await axios.post(this.api + '/like');
                if (response.data.success) {
                    this.likeCount = response.data.data.likeCount;
                    console.log('点赞成功，当前点赞数:', this.likeCount);
                }
            } catch (error) {
                console.error('点赞失败:', error);
            }
            
            // 先完全清理所有弹窗状态
            this.showPoster = false;
            this.newPoster = false;
            this.text = ''; // 清空之前的文本内容
            
            // 设置点赞分享标志
            this.isLikeShare = true;
            console.log('设置点赞分享标志:', this.isLikeShare);
            
            // 点赞分享直接进入第二个弹窗（图片分享），跳过链接分享
            // 增加延迟确保DOM完全更新
            setTimeout(() => {
                this.newPoster = true;
                
                // 确保第二个弹窗的缩放组件完全重置
                this.$nextTick(() => {
                    if (this.$refs.zoomableContent2) {
                        // 先完全重置状态
                        this.$refs.zoomableContent2.resetToInitialState();
                        // 然后重新计算
                        setTimeout(() => {
                            this.$refs.zoomableContent2.recalculate();
                        }, 50);
                    }
                });
            }, 100);
            
            // 等待DOM更新后绘制点赞图片到canvas
            this.$nextTick(() => {
                setTimeout(() => {
                    console.log('准备绘制点赞图片');
                    this.drawPosterPreview();
                }, 150); // 增加延迟，确保组件重置完成
            });
        },

        // 处理评论按钮（不改变状态，只执行功能）
        handleComment() {
            this.openComment();
        },

        prevView() {
            if (this.currentIndex > 0) {
                this.currentIndex--;
            } else {
                this.currentIndex = this.views.length - 1;
            }
            this.changeUsers();
            this.playCurrentAudio(); // 切换音频
            this.preloadAdjacentImages(); // 预加载相邻图片
        },

        nextView() {
            if (this.currentIndex < this.views.length - 1) {
                this.currentIndex++;
            } else {
                this.currentIndex = 0;
            }
            this.changeUsers();
            this.playCurrentAudio(); // 切换音频
            this.preloadAdjacentImages(); // 预加载相邻图片
        },

        // 预加载当前图片相邻的图片
        preloadAdjacentImages() {
            const totalViews = this.views.length;

            // 计算相邻图片的索引
            const nextIndex = (this.currentIndex + 1) % totalViews;
            const prevIndex = (this.currentIndex - 1 + totalViews) % totalViews;
            const nextNextIndex = (this.currentIndex + 2) % totalViews;

            // 预加载相邻图片
            this.preloadImage(this.views[nextIndex].image, 'high');
            this.preloadImage(this.views[prevIndex].image, 'medium');
            this.preloadImage(this.views[nextNextIndex].image, 'low');
        },

        changeUsers() {
            // 不再需要根据展厅切换人物列表
            // 搜索功能现在显示所有展厅的人物
            // 保留此方法以避免其他地方调用时出错
        },

        onPanoramaLoaded() {
            // 全景图加载完成的回调
        },

        // 处理视频开始播放
        handleVideoPlay() {

            // 保存当前音频状态
            this.audioStateBeforeVideo.voice = this.buttonStates.voice;
            this.audioStateBeforeVideo.music = this.buttonStates.music;

            // 暂停讲解音频
            if (this.buttonStates.voice && this.audioPlayer) {
                this.audioPlayer.pause();
            }

            // 暂停背景音乐
            if (this.buttonStates.music && this.bgMusicPlayer) {
                this.bgMusicPlayer.pause();
            }
        },

        // 处理视频关闭
        handleVideoClose() {

            // 恢复讲解音频
            if (this.audioStateBeforeVideo.voice && this.audioPlayer) {
                this.audioPlayer.play().catch(err => {
                    console.error('恢复讲解音频失败:', err);
                });
            }

            // 恢复背景音乐
            if (this.audioStateBeforeVideo.music && this.bgMusicPlayer) {
                this.bgMusicPlayer.play().catch(err => {
                    console.error('恢复背景音乐失败:', err);
                });
            }
        },

        handleSearch() {
            if (!this.searchKeyword.trim()) {
                this.searchResults = [];
                return;
            }

            const keyword = this.searchKeyword.toLowerCase().trim();
            this.searchResults = this.users.filter(user => {
                return user['名字'].toLowerCase().includes(keyword);
            }).slice(0, this.maxSearchResults);
        },

        selectSearchResult(result) {
            this.showSearch = false;
            this.searchKeyword = '';
            this.searchResults = [];

            // 保存人物所属的展厅
            this.selectedUserHall = result['展厅'] || 1;

            // 保存人物名字，用于分享标题
            this.selectedUserName = result['名字'] || '';

            // 不限制文字长度，显示完整事迹
            let text = result['事迹'] || '';
            this.text = text;
            
            // 先完全清理所有弹窗状态
            this.showPoster = false;
            this.newPoster = false;
            this.isLikeShare = false;
            
            // 打开人物分享弹窗
            // 增加延迟确保DOM完全更新
            setTimeout(() => {
                this.newPoster = true;
                
                // 确保第二个弹窗的缩放组件完全重置
                this.$nextTick(() => {
                    if (this.$refs.zoomableContent2) {
                        // 先完全重置状态
                        this.$refs.zoomableContent2.resetToInitialState();
                        // 然后重新计算
                        setTimeout(() => {
                            this.$refs.zoomableContent2.recalculate();
                        }, 50);
                    }
                });
            }, 100);

            // 绘制预览 Canvas
            this.$nextTick(() => {
                setTimeout(() => {
                    this.drawPosterPreview();
                }, 150); // 增加延迟，确保组件重置完成
            });

            // 如果在微信环境中，通知 App.vue 更新分享配置
            if (this.isWeChat && window.wxReady) {
                // 截取前100字作为描述
                let shareDesc = text;
                if (shareDesc.length > 100) {
                    shareDesc = shareDesc.substring(0, 100) + '...';
                }

                // 通过事件总线通知 App.vue 更新分享配置
                this.$root.$emit('update-wechat-share', {
                    characterName: this.selectedUserName,
                    title: `${this.selectedUserName} - 延庆区先进典型人物事迹展览`,
                    desc: shareDesc
                });
            }
        },



        // 获取点赞和分享统计数据
        async fetchStats() {
            try {
                // 获取点赞数
                const likeResponse = await axios.get(this.api + '/like');
                if (likeResponse.data.success) {
                    this.likeCount = likeResponse.data.data.likeCount;
                }

                // 获取分享数
                const shareResponse = await axios.get(this.api + '/share');
                if (shareResponse.data.success) {
                    this.shareCount = shareResponse.data.data.shareCount;
                }

            } catch (error) {
                console.error('获取统计数据失败:', error);
            }
        }
    },
}
</script>

<style scoped src="./View.css"></style>
